// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".ui-icon{width:1px;height:1px;cursor:pointer;display:inline-block}.ui-icon svg{fill:white}.ui-icon svg.active{fill:#3CD1BF}.ui-icon.active svg,.ui-icon:hover svg{fill:#3CD1BF}.ui-icon.disabled{opacity:0.25}.ui-icon.disabled svg{fill:#B3B3B3}.ui-icon .cls-2{fill:none !important}\n", ""]);
// Exports
module.exports = exports;
